import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClasesActivo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 31,
	height: 16,
	viewBox: "0 0 31 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.49374 16H7.07992C7.56351 16 8.02776 15.4332 8.02776 14.7118V1.26248C8.02776 0.618357 7.62154 0 7.07992 0H5.49374C4.9908 0 4.5459 0.541063 4.5459 1.26248V14.7118C4.5459 15.4332 4.95212 16 5.49374 16Z",
			fill: "#FF482E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.7662 14.2218H3.63667V1.77734H2.7662C2.28261 1.77734 1.81836 2.31841 1.81836 3.03982V13.0108C1.81836 13.6807 2.22458 14.2218 2.7662 14.2218Z",
			fill: "#FF482E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.464248 9.63563H0.909153V6.08008H0.464248C0.21278 6.08008 0 6.36349 0 6.69844V9.01728C0 9.35222 0.21278 9.63563 0.464248 9.63563Z",
			fill: "#FF482E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.6049 10H6.4123C6.18897 10 6 9.67883 6 9.32847V6.67153C6 6.29197 6.18897 6 6.4123 6H24.6049C24.8282 6 25 6.29197 25 6.67153V9.32847C25 9.67883 24.8282 10 24.6049 10Z",
			fill: "#FF482E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M25.5252 16H23.9391C23.4361 16 22.9912 15.4332 22.9912 14.7118V1.26248C22.9912 0.618357 23.3974 0 23.9391 0H25.5252C26.0088 0 26.4731 0.541063 26.4731 1.26248V14.7118C26.4731 15.4332 26.0669 16 25.5252 16Z",
			fill: "#FF482E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M28.2339 14.2218H27.3828V1.77734H28.2339C28.7369 1.77734 29.2011 2.31841 29.2011 3.03982V13.0108C29.2011 13.6807 28.7756 14.2218 28.2339 14.2218Z",
			fill: "#FF482E"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M30.5551 9.63563H30.0908V6.08008H30.5551C30.7872 6.08008 31 6.36349 31 6.69844V9.01728C31 9.35222 30.7872 9.63563 30.5551 9.63563Z",
			fill: "#FF482E"
		})
	]
});
export default SvgClasesActivo;
